import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const OrderClimaticFeatureForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Dia ensolarado", value: "clear-day" },
    { label: "Noite aberta", value: "clear-night" },
    { label: "Nublado", value: "cloudy" },
    { label: "Dia parcialmente nublado", value: "partly-cloudy-day" },
    { label: "Noite parcialmente nublada", value: "partly-cloudy-night" },
    { label: "Neblina", value: "fog" },
    { label: "Ventania", value: "wind" },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.OrderClimaticFeature}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
